import Base from "./base";

export default class AnindaMft extends Base {

    makeExternalPayment(newStep){
        this.props.externalFunc.depositAnindaMFT({
            amount: parseInt(this.state.stake),
            language: this.getActiveLanguageCode()
        }, (data) => {
            this.setState({
                externalUrl: data.payment_url,
                currentStep: newStep
            })
        });
    }

    makeExternalPaymentWithBonus(newStep, bonusId){
        const {selectedDeposit} = this.props;
        this.props.externalFunc.depositAnindaMFT({
            amount: parseInt(this.state.stake),
            language: this.getActiveLanguageCode(),
            claimsBonus: true,
            bonusId: bonusId
        }, (data) => {
            this.setState({
                externalUrl: data.payment_url,
                currentStep: newStep
            })
        });
    }
}
